import {useTranslation} from 'react-i18next'
import {NotFound as NotFoundLib} from '@components/lib'

import routes from 'routes/pathConfig'
import {TokenInfo} from 'constData'

const NotFound = () => {
  const {t} = useTranslation()
  return (
    <NotFoundLib
      homePath={routes.home.path}
      contactEmail={TokenInfo.V999.emailSupport}
      texts={{
        title: t('notFound.title'),
        description: t('notFound.subTitle'),
        homeButton: t('notFound.mainPageBtn'),
        contactButton: t('notFound.mainContactBtn'),
      }}
    />
  )
}

export default NotFound
